import React, { useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
} from "@mui/material";
import { useCreateData, useDeleteTableDataPreset } from "../Plan/tableHooks";
import * as S from "./styles";
import Loading from "../Loading/Loading";
import { CancelButton, SaveButton } from "../../common/Buttons";

function DateScheduleEditor({
  date,
  presets,
  onComplete,
  initialData,
  openSnackbar,
  group_code,
  project_code,
}) {
  const [isHoliday, setIsHoliday] = useState(initialData?.isHoliday || false);
  const [selectedPreset, setSelectedPreset] = useState(
    initialData?.typeId || ""
  );
  const [description, setDescription] = useState(
    initialData?.description || ""
  );
  const { mutate: createMutate, isPending: isCreateLoading } = useCreateData(
    true,
    "/api/factory/createSpecTime",
    openSnackbar
  );
  const { mutate: deleteMutate, isPending: isDeleteLoading } =
    useDeleteTableDataPreset(true, "/api/factory/deleteSpecTime", true);
  const isEditMode = initialData?.typeId !== undefined;
  const handleSubmit = () => {
    const requestObj = {
      date: date,
      type_id: isHoliday ? -1 : selectedPreset,
      description,
      group_code,
      project_code,
    };
    createMutate(requestObj, {
      onSuccess: () => {
        console.log("success? ");
        openSnackbar("일정이 성공적으로 등록되었습니다.");
        onComplete();
      },
    });
  };
  const handleDelete = () => {
    deleteMutate(
      { id: date, group_code, project_code },
      {
        onSuccess: () => {
          openSnackbar("일정이 성공적으로 삭제되었습니다.");
          onComplete();
        },
        onError: (e) => {
          openSnackbar(e.response.data.message);
        },
      }
    );
  };
  return (
    <>
      {(isCreateLoading || isDeleteLoading) && <Loading />}
      <S.EditorContainerDateSchM>
        <Typography variant="h6" gutterBottom>
          일정 {isEditMode ? "수정" : "등록"}
        </Typography>
        <S.FormGroupDateSchM>
          <FormControl>
            <InputLabel>휴일 여부</InputLabel>
            <Select
              value={isHoliday}
              onChange={(e) => setIsHoliday(e.target.value)}
              label="휴일 여부"
            >
              <MenuItem value={false}>일반</MenuItem>
              <MenuItem value={true}>휴일</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            disabled={isHoliday}
            sx={{
              "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "#f5f5f5",
                cursor: "not-allowed",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#e0e0e0",
                },
              },
              "& .MuiInputLabel-root.Mui-disabled": {
                color: "#9e9e9e",
              },
              "& .MuiSelect-icon.Mui-disabled": {
                color: "#9e9e9e",
              },
            }}
          >
            <InputLabel>
              {isHoliday ? "선택 불가" : "근무시간 유형 선택"}
            </InputLabel>
            <Select
              value={selectedPreset}
              onChange={(e) => setSelectedPreset(e.target.value)}
              label="유형 선택"
              sx={{
                "&.Mui-disabled": {
                  WebkitTextFillColor: "#757575",
                },
              }}
            >
              {presets.map((preset) => (
                <MenuItem key={preset.id} value={preset.id}>
                  {preset.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="설명"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
          />
        </S.FormGroupDateSchM>
        <S.ButtonGroupDateSchM>
          {isEditMode && (
            <Button color="error" variant="contained" onClick={handleDelete}>
              삭제
            </Button>
          )}
          <SaveButton
            onClick={handleSubmit}
            disabled={!isHoliday && !selectedPreset}
          />
          <CancelButton onClick={onComplete} />
        </S.ButtonGroupDateSchM>
      </S.EditorContainerDateSchM>
    </>
  );
}

export default DateScheduleEditor;
